import { useEffect } from 'react';

const SITE_NAME = 'Circuit-Slot';
const DEFAULT_OG_IMAGE = 'https://circuit-slot.fr/og-image.jpg';
const DEFAULT_DESCRIPTION = 'Circuit-Slot, votre spécialiste en circuits de slot, voitures, pièces détachées et accessoires. Scalextric, Carrera, NSR, Ninco. Livraison rapide en France.';

function setMeta(selector, attrName, attrValue, content) {
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attrName, attrValue);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export default function usePageTitle(title, description, options = {}) {
  useEffect(() => {
    const desired = title
      ? `${title} | ${SITE_NAME}`
      : `${SITE_NAME} — Le spécialiste du circuit de slot`;

    document.title = desired;

    // Forcer le favicon
    const forceFavicon = () => {
      const links = document.querySelectorAll("link[rel*='icon']");
      links.forEach(l => l.parentNode.removeChild(l));
      const link = document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/png';
      link.href = '/favicon.png';
      document.head.appendChild(link);
    };
    forceFavicon();

    // Observer pour forcer le titre ET le favicon si la plateforme les réécrit
    let observing = false;
    const observer = new MutationObserver(() => {
      if (!observing) return;
      // Disconnect before making changes to prevent re-entrant loops
      observer.disconnect();
      observing = false;
      if (document.title !== desired) document.title = desired;
      const favicon = document.querySelector("link[rel*='icon']");
      if (!favicon || favicon.href !== window.location.origin + '/favicon.png') {
        forceFavicon();
      }
      // Re-observe after changes
      observer.observe(document.head, { subtree: true, characterData: true, childList: true });
      observing = true;
    });

    observer.observe(document.head, {
      subtree: true,
      characterData: true,
      childList: true,
    });
    observing = true;

    // Meta description + Open Graph + Twitter Card (spécifiques à la page)
    const desc = (description ? description.slice(0, 160) : DEFAULT_DESCRIPTION).trim();
    const image = options.image || DEFAULT_OG_IMAGE;
    setMeta('meta[name="description"]', 'name', 'description', desc);
    setMeta('meta[property="og:title"]', 'property', 'og:title', desired);
    setMeta('meta[property="og:description"]', 'property', 'og:description', desc);
    setMeta('meta[property="og:type"]', 'property', 'og:type', options.type || 'website');
    setMeta('meta[property="og:image"]', 'property', 'og:image', image);
    setMeta('meta[name="twitter:title"]', 'name', 'twitter:title', desired);
    setMeta('meta[name="twitter:description"]', 'name', 'twitter:description', desc);
    setMeta('meta[name="twitter:image"]', 'name', 'twitter:image', image);
    setMeta('meta[name="twitter:card"]', 'name', 'twitter:card', 'summary_large_image');

    return () => observer.disconnect();
  }, [title, description, options.image, options.type]);
}